import { Pipe, PipeTransform } from '@angular/core';
const { DateTime } = require("luxon");
@Pipe({
    name: 'utcDate'
})
export class UtcDatePipe implements PipeTransform {

    transform(value: string): any {

        if (!value) {
            return '';
        }
        // console.warn('UTCDatePipe : input = ', value);
        const dateWithNoTimezone = DateTime.fromISO(value).toFormat('LLL d, yyyy');
        // console.log('UTCDatePipe : output = ', dateWithNoTimezone);
        return dateWithNoTimezone;
    }
}



// WEBPACK FOOTER //
// ./src/directives/utc-date-pipe.ts